<template>
  <div>
    <div class="bottom">
      <div class="m_txt">
        <span>* 어닝 판단 기준 : 희석주당순이익 컨센서스 대비 변화율</span>
        <span>* 출처 : EDGAR 실적공시(8-K, 10-Q, 10-K), GAAP기준 (Non-GAAP 확보시 우선 적용)</span>
        <span>* 공시 규격 6-K의 ADR종목은 제공되지 않음</span>
      </div>
      <div class="guide_m">
        <button @click="openToggle">이용<br />안내</button>
      </div>
    </div>
    <div class="swipe" id="swipe">
      <img
        src="https://img.thinkpool.com/concert/us/kiwoom/usRecode/img/swipe.png"
        alt="스와이프"
        width="50%"
      />
    </div>
    <section>
      <!-- //guide_m -->
      <div class="guide_pop_m" @click="openToggle">
        <div class="box">
          <div class="tit">
            <strong>이용 안내</strong>
            <em>* 어닝 판단에 대한 기준은 아래와 같습니다.</em>
          </div>
          <!-- //tit -->

          <table width="100%">
            <colgroup>
              <col width="95" />
              <col width="*" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">표기</th>
                <th scope="col">기준</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>어닝서프라이즈</td>
                <td>컨센서스 대비 0 ~ +15% 이상</td>
              </tr>
              <tr>
                <td>예상수준상회</td>
                <td class="lst">컨센서스 대비 5% ~ 15% 미만</td>
              </tr>
              <tr>
                <td>예상치부합</td>
                <td>컨센서스 대비 -5% ~ 5% 미만</td>
              </tr>
              <tr>
                <td>예상수준하회</td>
                <td>컨센서스 대비 -5 % ~ -15% 미만</td>
              </tr>
              <tr class="end">
                <td>어닝쇼크</td>
                <td>컨센서스 대비 -15% 이하</td>
              </tr>
            </tbody>
          </table>
          <!-- //table -->
          <div class="txt">
            * 본 서비스는 속보 서비스로 최근일로부터 약 4개월간의 데이터만 제공됩니다.
          </div>

          <div class="gm_txt">
            <strong>이용상의 주의 사항 </strong>

            <span>
              금융시장의 변동에 따라 실적 발표 일정과 공시는 지속적으로 변동됩니다.
              <br /><br />
              본 서비스는 미국 실적 공시를 실시간 데이터화 하여 제공함에 있어 공시의 오류, 데이터
              수집 프로세스상의 에러 및 지연 등 다양한 서비스상의 오류와 지연이 있을 수 있습니다.
              <br /><br />
              본 서비스를 이용함에 있어 그 이용에 따르는 책임은 이용자 본인에게 있으며, 어떠한 거래
              손실이나 다른 손실에 대해서도 책임지지 않습니다.
            </span>
          </div>
          <!-- //gm_txt -->
          <div class="gm_btn">
            <a href="javascript:;">닫 기</a>
          </div>
        </div>
        <div class="bg"></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    openToggle () {
      $('.guide_pop_m').toggle()
    }
  },
  created () {
    if ('ontouchstart' in window) {
      document.addEventListener('touchstart', function () { $('#swipe').hide() }
      )
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/kiwoom/usRecord/mb/common/BottomInfo.vue